import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import ChangeRate from "../ChangeRate/ChangeRate";
import WithAsterisk from "../WithAsterisk/WithAsterisk";
import NumberService from "../../../Services/Shared/Number.service";
export const BigNumberHelpers = {
    limitPercentTo100WithWarning: (decimal, 
    /**
     * A warning or a function which takes in the actual percentage and returns a string (for when you want to include
     * the actual percentage in the warning).
     */
    warning) => {
        const getWarning = () => typeof warning === "function"
            ? warning(NumberService.asPercentage(decimal) + "%")
            : warning;
        return {
            number: NumberService.asPercentage(Math.min(1, decimal)) + "%",
            warning: decimal > 1 ? getWarning() : null,
        };
    },
    limitPercentTo100: (decimal) => ({
        number: NumberService.asPercentage(Math.min(1, decimal)) + "%",
    }),
};
const BigNumber = ({ title, number, subtitle, change, warning }) => (_jsxs("div", { className: "d-flex flex-column align-items-center", children: [_jsx("div", { children: title }), _jsx("div", { style: { fontSize: 30 }, children: warning ? (_jsx(WithAsterisk, { message: warning, children: number.toString() })) : (number) }), subtitle && _jsx("div", { className: "text-muted", children: subtitle }), change && (_jsx(ChangeRate, { currentValue: change.currentValue, previousValue: change.previousValue }))] }));
export default BigNumber;
